module.exports = __webpack_public_path__ + "static/media/prompt_engineering.d683c27a.png";